import React from 'react';

const PageEntries = ({ start, end, totalCount }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between sm:justify-start gap-2 text-sm text-gray-600">
      <div className="font-medium">
        Showing <span className="font-semibold text-gray-800">{start}</span> to{' '}
        <span className="font-semibold text-gray-800">{end}</span> of{' '}
        <span className="font-semibold text-gray-800">{totalCount}</span> entries
      </div>
    </div>
  );
};

export default PageEntries;